import useCreateSizingExperiment from "@babackapp/private-api-client/client/use-create-sizing-experiment";
import { Button } from "@babackapp/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { Input } from "@babackapp/ui/components/input";
import { Label } from "@babackapp/ui/components/label";
import { Plus } from "lucide-react";
import { useState } from "react";

interface CreateExperimentDialogProps {
  shopId: string;
}

export function CreateExperimentDialog({
  shopId,
}: CreateExperimentDialogProps) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [splitPercent, setSplitPercent] = useState("50");
  const mutation = useCreateSizingExperiment(shopId);

  function handleCreate() {
    const split = parseInt(splitPercent, 10);
    if (!name.trim() || !Number.isFinite(split) || split < 0 || split > 100) {
      return;
    }

    mutation.mutate(
      { name: name.trim(), splitPercent: split },
      {
        onSuccess: () => {
          setOpen(false);
          setName("");
          setSplitPercent("50");
        },
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm">
          <Plus className="h-4 w-4 mr-1" />
          New experiment
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create experiment</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="exp-name">Name</Label>
            <Input
              id="exp-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Q3 2026 sizing test"
              maxLength={120}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="exp-split">
              Split % (visitors who see the widget)
            </Label>
            <Input
              id="exp-split"
              type="number"
              min={0}
              max={100}
              step={1}
              value={splitPercent}
              onChange={(e) => setSplitPercent(e.target.value)}
            />
          </div>
          <div className="flex justify-end">
            <Button
              onClick={handleCreate}
              disabled={
                mutation.isPending || !name.trim() || !splitPercent
              }
            >
              {mutation.isPending ? "Creating..." : "Create"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
